import { PhotoDisplayHandler } from "components";
import { BASE_URL } from "config/constants";
import LinkLanguage from "locales/LinkLanguage";
import "./PartnerCard.scss";

const PartnerCard = ({
  title,
  picture,
  url,

  slug,
}: any) => {
  return (
    <LinkLanguage
      className="Partner-Card"
      to={"/about/" + slug}
      key={title}
      title={`Vidi detaljno ${title}`}
    >
      <div className="Partner-Image">
        <PhotoDisplayHandler
          img_name={picture}
          calculate={false}
          img_class_name=""
          img_alt={title}
          width="100%"
          height="auto"
        />
      </div>
    </LinkLanguage>
  );
};

export default PartnerCard;
